import axios from 'axios';

import { CATALOGUE_ENDPOINT } from '../consts';

const EVENT_NAME_DELETE = 'remove';
const EVENT_NAME_ADD = 'add';

const sendRequestToCatalogue = ({
  id,
  csrfToken,
  onResponse,
  onError,
  eventType,
  myCatalogueRemove,
}) => {
  const payload = { id, eventType, myCatalogueRemove };
  axios
    .post(CATALOGUE_ENDPOINT, payload, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'X-CSRFToken': csrfToken,
      },
    })
    .then(onResponse)
    .catch(onError);
};

export const addToCatalogue = ({
  id,
  csrfToken,
  onResponse = () => {},
  onError = () => {},
}) => {
  sendRequestToCatalogue({
    id,
    csrfToken,
    onResponse,
    onError,
    eventType: EVENT_NAME_ADD,
  });
};

export const removeFromCatalogue = ({
  id,
  myCatalogueRemove,
  csrfToken,
  onResponse = () => {},
  onError = () => {},
}) => {
  sendRequestToCatalogue({
    id,
    csrfToken,
    onResponse,
    onError,
    eventType: EVENT_NAME_DELETE,
    myCatalogueRemove,
  });
};
